import { render, staticRenderFns } from "./DigestList.vue?vue&type=template&id=c922ceba&"
import script from "./DigestList.vue?vue&type=script&lang=js&"
export * from "./DigestList.vue?vue&type=script&lang=js&"
import style0 from "./DigestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports